import {Injectable} from '@angular/core';
import {AppStatusesService} from 'app/features/apps/services/app-statuses.service';
import {AppList} from 'app/features/apps/interfaces/app-list.interface';
import {AlertStatus} from 'app/core/interfaces/alert.interface';
import moment from 'moment-mini';

@Injectable()
export class AppNewReleaseNotifierService extends AppStatusesService {
    today = moment(new Date()).format('YYYY-MM-DD');

    get currentUser() {
        return this.auth.getCurrentUserLastValue();
    }

    key(): string {
        return 'DontShowNewReleaseNotificationAgain' + this.auth.currentUserId;
    }

    shouldShowNotification(apps: AppList): boolean {
        if (!this.currentUser.isSdkOutdated) {
            return false;
        }

        const releaseNotification = this.localStorage.getItem(this.key());
        if (!releaseNotification) {
            return true;
        }

        let savedDate = moment(releaseNotification);
        return savedDate.isBefore(this.today);
    }

    public markAsClosed() {
        this.localStorage.setItem(this.key(), String(this.today));
    }

    showWarning() {
        this.localeAlerts.addAlert(this.i18next.transform('appSettings.alert'), AlertStatus.strongWarning, () => this.markAsClosed());
    }
}
